import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --sectionSpacing: ${fluid(24, 64)};

  ${SectionWrapperStyles.Inner} {
    ${baseGrid};
  }
`;
const SavingsProductFinderStyles = {
    Container,
};
export default SavingsProductFinderStyles;
